import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const newPasswordControl = control.get('newPassword');
    const confirmPasswordControl = control.get('confirmPassword');

    const newPassword = newPasswordControl?.value;
    const confirmPassword = confirmPasswordControl?.value;

    const isNewPasswordEmpty = !newPassword;
    const isConfirmPasswordEmpty = !confirmPassword;

    if (isNewPasswordEmpty && isConfirmPasswordEmpty) {
      confirmPasswordControl?.setErrors(null);
      return null;
    }

    if (!isNewPasswordEmpty && isConfirmPasswordEmpty) {
      confirmPasswordControl?.setErrors({
        required: true,
      });

      return {
        confirmPasswordRequired: true,
      };
    }

    if (isNewPasswordEmpty && !isConfirmPasswordEmpty) {
      newPasswordControl?.setErrors({
        required: true,
      });

      return {
        newPasswordRequired: true,
      };
    }

    if (newPassword !== confirmPassword) {
      confirmPasswordControl?.setErrors({
        passwordMismatch: true,
      });

      return {
        passwordMismatch: true,
      };
    }

    confirmPasswordControl?.setErrors(null);

    return null;
  };
}
